import { render, staticRenderFns } from "./DetailFooter.vue?vue&type=template&id=c32f0670&scoped=true&"
import script from "./DetailFooter.vue?vue&type=script&lang=js&"
export * from "./DetailFooter.vue?vue&type=script&lang=js&"
import style0 from "./DetailFooter.vue?vue&type=style&index=0&id=c32f0670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32f0670",
  null
  
)

export default component.exports